import React, { PureComponent } from 'react';

export default class Tooltip extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            tooltip: {},
            position: {
                top: 0,
                left: 0
            }
        };

        this.isOpenPopup = this.isOpenPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showTooltipContent = this.showTooltipContent.bind(this);

        this.wrapperRef = React.createRef();
        this.wrapperRef1 = React.createRef();
    }
      
    isOpenPopup(e, emoji) {
        e.persist();
        let {item={}} = this.state.tooltip;
       // console.log('item', item);
        if (!Object.keys(item).length || (item.id != emoji.id)) {
            this.setState({
                isOpen: true,
                tooltip: {
                    item: emoji,
                    e: e
                }
            }, () => {
                let e1 = this.wrapperRef1;
                if (e1 != null) {
                    const {e} = this.state.tooltip;
                    let ore = e.target;
                    if (!e.target.classList.contains("reacted-emoji-icon")) {
                        if (e.target.parentNode) {
                            ore = e.target.parentNode;
                        }
                    }           
                    let {height = 0, width = 0} = e1.getBoundingClientRect();
                    let top = ore.offsetTop - height;
                    let left = ore.offsetLeft - (width / 2) + 25;
                    this.setState({
                        position: {...this.state.position, ...{top, left}}
                    });
                }
            });
        }
    }

    closePopup(e, emoji) {
        e.persist();
        setTimeout(() => {
            this.setState({
                tooltip: {},
                isOpen: false
            });
        }, this.props.delayTooltip);
       
    }

    showTooltipContent() {
        let {emoji={}} = this.props;
        let users = emoji.users.map( u => u.name).join(', ');
        return (
            <div className='reaction-emoji-tooltip-content'>
                { users.length > 103 
                    ? users.substring(0, 100) + "..."
                    : users

                }
            </div>
        );
    }

    render() {
        let {children, emoji={},krRowEmojis} = this.props;
        let tooltipCss = {
            display: (this.state.isOpen ? 'block' : 'none')
        };
        let {position} = this.state;
        tooltipCss = {...tooltipCss, ...position};
       
       // users = `react tooltip, example codepen, test asdf adsf, adf adsf, asdf adsf,asd fdsf s, react tooltip, example codepen, test asdf adsf, adf adsf, asdf adsf,asd fdsf s, pandi kamal test asdf adsf, adf adsf, asdf adsf,asd fdsf s, pandi kamal`;
        return (
            <div 
                className='wbtooltip-wrapper'
                style={{display: krRowEmojis ? 'flex' : ''}}
                onMouseOver={(e) => this.isOpenPopup(e, emoji)}
                onMouseLeave={(e) => this.closePopup(e, emoji)}
                onFocus={(e) => this.isOpenPopup(e, emoji)}
                onBlur = {(e) => this.closePopup(e, emoji)}
                ref={node => (this.wrapperRef = node)}
            >
                {children}
                {
                    this.state.isOpen ?
                        <div 
                            className='reaction-emoji-tooltip-wrapper' 
                            style={tooltipCss}
                            ref={node => (this.wrapperRef1 = node)}
                            >
                            {
                                this.showTooltipContent()
                            }
                        </div>
                    : ''
                }
            </div>
        );
    }
}

Tooltip.defaultProps = {
    emoji: {},
    delayTooltip: 100
};